export const RIGHT_POLICYHOLDER_SEARCH = 150101
export const RIGHT_POLICYHOLDER_CREATE = 150102
export const RIGHT_POLICYHOLDER_UPDATE = 150103
export const RIGHT_POLICYHOLDER_DELETE = 150104
export const RIGHT_POLICYHOLDERINSUREE_SEARCH = 150201
export const RIGHT_POLICYHOLDERINSUREE_CREATE = 150202
export const RIGHT_POLICYHOLDERINSUREE_UPDATE = 150203
export const RIGHT_POLICYHOLDERINSUREE_DELETE = 150204
export const RIGHT_POLICYHOLDERINSUREE_REPLACE = 150206
export const RIGHT_POLICYHOLDERUSER_SEARCH = 150301
export const RIGHT_POLICYHOLDERUSER_CREATE = 150302
export const RIGHT_POLICYHOLDERUSER_UPDATE = 150303
export const RIGHT_POLICYHOLDERUSER_DELETE = 150304
export const RIGHT_POLICYHOLDERUSER_REPLACE = 150306
export const RIGHT_POLICYHOLDERCONTRIBUTIONPLANBUNDLE_SEARCH = 150401
export const RIGHT_POLICYHOLDERCONTRIBUTIONPLANBUNDLE_CREATE = 150402
export const RIGHT_POLICYHOLDERCONTRIBUTIONPLANBUNDLE_UPDATE = 150403
export const RIGHT_POLICYHOLDERCONTRIBUTIONPLANBUNDLE_DELETE = 150404
export const RIGHT_POLICYHOLDERCONTRIBUTIONPLANBUNDLE_REPLACE = 150406
export const DATE_TO_DATETIME_SUFFIX = "T00:00:00"
export const GREATER_OR_EQUAL_LOOKUP = "Gte"
export const LESS_OR_EQUAL_LOOKUP = "Lte"
export const CONTAINS_LOOKUP = "Icontains"
export const STARTS_WITH_LOOKUP = "Istartswith"
export const DEFAULT_PAGE_SIZE = 10
export const ROWS_PER_PAGE_OPTIONS = [10, 20, 50, 100]
export const POLICYHOLDERINSUREE_TAB_VALUE = "policyHolderInsureesTab"
export const POLICYHOLDERCONTRIBUTIONPLANBUNDLE_TAB_VALUE = "policyHolderContributionPlanBundlesTab"
export const POLICYHOLDERUSER_TAB_VALUE = "policyHolderUsersTab"
export const MAX_CODE_LENGTH = 32
export const MAX_TRADENAME_LENGTH = 255
export const MAX_ADDRESS_LENGTH = 1024
export const MAX_PHONE_LENGTH = 16
export const MAX_FAX_LENGTH = 16
export const MAX_EMAIL_LENGTH = 255
export const MAX_ACCOUNTANCYACCOUNT_LENGTH = 64
export const MAX_PAYMENTREFERENCE_LENGTH = 128
export const ZERO = 0
export const MAX_CLIENTMUTATIONLABEL_LENGTH = 255
export const POLICYHOLDERINSUREE_CALCULATION_CONTRIBUTION_KEY = "policyHolder.PolicyHolderInsuree.calculation"
export const POLICYHOLDERINSUREE_CLASSNAME = "PolicyHolderInsuree"
export const RIGHT_CALCULATION_WRITE = "write"
export const RIGHT_CALCULATION_UPDATE = "update"
export const RIGHT_CALCULATION_REPLACE = "replace"
export const RIGHT_PORTALPOLICYHOLDER_SEARCH = 154001
export const RIGHT_PORTALPOLICYHOLDERINSUREE_SEARCH = 154101
export const RIGHT_PORTALPOLICYHOLDERINSUREE_CREATE = 154102
export const RIGHT_PORTALPOLICYHOLDERINSUREE_UPDATE = 154103
export const RIGHT_PORTALPOLICYHOLDERINSUREE_DELETE = 154104
export const RIGHT_PORTALPOLICYHOLDERINSUREE_REPLACE = 154106
export const RIGHT_PORTALPOLICYHOLDERCONTRIBUTIONPLANBUNDLE_SEARCH = 154601
export const RIGHT_PORTALPAYMENT_SEARCH = 154501
export const RIGHT_PORTALPOLICYHOLDERUSER_SEARCH = 154401
export const RIGHT_PORTALPOLICYHOLDERUSER_CREATE = 154402
export const RIGHT_PORTALPOLICYHOLDERUSER_UPDATE = 154403
export const RIGHT_PORTALPOLICYHOLDERUSER_DELETE = 154404
export const RIGHT_PORTALPOLICYHOLDERUSER_REPLACE = 154406
export const RIGHT_PAYMENT_SEARCH = 101401
export const MODULE_NAME = "policyHolder";
export const ECONOMIC_UNIT_STORAGE_KEY = 'userEconomicUnit';
export const REF_PUBLIC_GDPR_PAGE = 'workerVoucher.route.gdpr';

export const RIGHT_VIEW_EU_MODAL = 203000;
